import { Profile } from 'model/User'
import { OnRequestChangeCallback } from 'services/APIs/BaseAPI'
import { UserDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { InternalAPI } from 'services/APIs/InternalAPI/InternalAPI'
import { IUserAPI } from './PartyAccessController'

export class UserAPI extends InternalAPI implements IUserAPI {
  constructor(private onRequestChange: OnRequestChangeCallback) {
    super('/api/user')
  }

  public async GetProfile() {
    return await this.GetAsync<UserDto>({
      relativePath: '',
      id: 'get-profile',
      onRequestChange: this.onRequestChange,
    })
  }

  public async SaveProfile(profile: Profile) {
    return await this.PutAsync<UserDto>({
      relativePath: '',
      data: profile,
      id: 'save-profile',
      onRequestChange: this.onRequestChange,
    })
  }
}
